import { makeStyles, Text } from '@rneui/themed'
import { onlineManager } from '@tanstack/react-query'
import { t } from 'app/i18l'
import React, { useEffect, useState } from 'react'
import { Alert, Modal, Platform, Pressable, View } from 'react-native'
import { useCalendarSyncContext } from './context'

export default function CalendarSyncModal({}: {}) {
  const {
    initiateCalendarSync,
    calendarSyncSettingValue,
    setCalendarSyncSettingValue,
    setHideCalendarSyncModal,
    hideCalendarSyncModal,
  } = useCalendarSyncContext()
  const [modalVisible, setModalVisible] = useState(false)
  const styles = useStyles()

  useEffect(() => {
    if (
      calendarSyncSettingValue === false &&
      hideCalendarSyncModal === null &&
      Platform.OS !== 'web' &&
      onlineManager.isOnline()
    ) {
      setModalVisible(true)
    }
  }, [calendarSyncSettingValue, hideCalendarSyncModal])

  return (
    <View>
      <Modal animationType="slide" transparent={true} visible={modalVisible}>
        <View style={styles.container}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>{t('addShiftsToCalendar')}</Text>
            <View style={styles.linksContainer}>
              <Pressable
                onPress={() => {
                  setHideCalendarSyncModal(true)
                  setCalendarSyncSettingValue(true)
                  initiateCalendarSync().catch(null)
                  setModalVisible(!modalVisible)
                }}
              >
                <Text style={styles.link}>{t('yes')}</Text>
              </Pressable>
              <Pressable
                onPress={() => {
                  setHideCalendarSyncModal(true)
                  setModalVisible(!modalVisible)
                  Alert.alert(t('calendarSyncAlert'))
                }}
              >
                <Text style={styles.link}>{t('notNow')}</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 20,
  },
  modalView: {
    margin: 10,
    backgroundColor: theme.colors?.white,
    borderRadius: 20,
    padding: 25,
    alignItems: 'center',
    shadowColor: theme.colors?.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
    fontSize: 18,
    color: theme.colors?.black,
  },
  linksContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  link: {
    color: theme.colors?.blue,
    textDecorationLine: 'underline',
    marginHorizontal: 10,
    fontSize: 16,
  },
}))
